import PropTypes from 'prop-types'

import ImageUpload from '../pro/src/components/admin/ImageUpload'

import './logoUpload.scss'

const LogoUpload = ({altText = 'logo', logoUrl, setLogoUrl}) => (
  <div className='logo-upload'>
    {logoUrl && (
      <img
        alt={altText}
        className='logo'
        src={logoUrl}
      />
    )}
    <ImageUpload onImageLoad={url => setLogoUrl(url)}>
      <button className='upload-action'>{logoUrl ? 'Change' : 'Upload'}</button>
    </ImageUpload>
  </div>
)

LogoUpload.propTypes = {
  altText: PropTypes.string,
  logoUrl: PropTypes.string,
  setLogoUrl: PropTypes.func
}

export default LogoUpload